//Functions needed to copy  list of songs

$( document ).ready(function() {

const $list = $('#event-songs-list');
if ($list.length > 0){

    let scrollable = true;
    let mousePositionY = false;
    let scrollInterval;
    const windowHeight = $( window ).height();
    const closeToTopEdge = 0.1 * windowHeight;
    const closeToBottomEdge = windowHeight - closeToTopEdge;
    const isMobile = $('body').hasClass('mobile');

    const scrollSpeedFactor = isMobile ? 4 : 1;

    document.addEventListener('touchmove', function(e) {

        const touch = e.touches[0];
        mousePositionY = touch.clientY;

        if (!scrollable) {
            e.preventDefault();
        }
    }, { passive:false });

    document.addEventListener('mousemove', function(e) {
        mousePositionY = e.screenY;
    });

   dragula([document.getElementById("event-songs-list")], {
      direction: 'vertical',
      moves: function (el, container, handle) {
        return handle.classList.contains('dragula-handle');
      }
    })
   .on('drag', function(el, source) {
        scrollable = false;
        scrollInterval = setInterval(()=>{

            if(mousePositionY < closeToTopEdge){
                const howCloseToEdge = Math.abs(mousePositionY/closeToTopEdge);
                // Scroll up a bit (the closer to edge, the faster)
                window.scrollBy(0, -20 * howCloseToEdge * scrollSpeedFactor);
            } else if (mousePositionY > closeToBottomEdge){
                const howCloseToEdge = Math.abs((windowHeight-mousePositionY)/(closeToTopEdge));
                // Scroll down a bit (the closer to edge, the faster)
                window.scrollBy(0, 20 * howCloseToEdge * scrollSpeedFactor);
            }
        }, 100);
    })
   .on('drop', function (el) {
        scrollable = true;
        clearInterval(scrollInterval);
        setSongsOrder($list);
    })
    .on('dragend', function(el, source) {
        scrollable = true;
        clearInterval(scrollInterval);
    });

  $('#searchList .searchItem').on('click', (e)=>{
    const $this = $(e.currentTarget);
    addToList($this.data('song-id'), $this.data('song-duration'));
    setSongsOrder();
  });

  $('.remove', $list).on('click', (e)=>{
    const $this = $(e.currentTarget);
    removeFromList($this.data('song-id'), $this.data('song-duration'));
    setSongsOrder()
  });
}

$('.list-move-up').on('click', function(e) {
    let $wrapper = $(this).closest('.selectedSongs');
    let $prev = $wrapper.prevAll(':not(.d-none)');
    if($prev){
        $wrapper.fadeOut(200, ()=>{
            $wrapper.insertBefore($prev.first());
            $wrapper.fadeIn(200);
            setSongsOrder();
        });
    }
})
$('.list-move-down').on('click', function(e) {
    let $wrapper = $(this).closest('.selectedSongs');
    let $next = $wrapper.nextAll(':not(.d-none)');
    if($next){
        $wrapper.fadeOut(200, ()=>{
            $wrapper.insertAfter($next.first());
            $wrapper.fadeIn(200);
            setSongsOrder();
        });
    }
})

$('.selectedSongs:not(.d-none)', $list).last().addClass('last-of-type');

function setSongsOrder(){
    const $songs = $('.selectedSongs', $list);
    let itemOrder = 0;
    $songs.each((i, song) => {
        const $song = $(song);
        $song.removeClass('last-of-type');
        if(!$song.hasClass('d-none')){
            itemOrder += 1;
            $('.song-order-input input', $song).val(itemOrder);
            $('.song-order', $song).text(itemOrder);
        }
    });
    $('.selectedSongs:not(.d-none)', $list).last().addClass('last-of-type');
}



function clearPastSelect() {
    document.getElementById("previous").options[0].selected = 'selected';

    const $copySongsFromEventForm = $('#copy-songs-from-other-event-form');
    if($('#future', $copySongsFromEventForm).val() !== ''){
        $('button', $copySongsFromEventForm).removeClass('disabled');
    } else {
        $('button', $copySongsFromEventForm).addClass('disabled');
    }
}

function clearFutureSelect() {
    document.getElementById("future").options[0].selected = 'selected';

    const $copySongsFromEventForm = $('#copy-songs-from-other-event-form');
    if($('#previous', $copySongsFromEventForm).val() !== ''){
        $('button', $copySongsFromEventForm).removeClass('disabled');
    } else {
        $('button', $copySongsFromEventForm).addClass('disabled');
    }
}

// Initialize event listeners for copy songs form
$(document).ready(function() {
    const $futureSelect = $('#future');
    const $pastSelect = $('#previous');
    
    if ($futureSelect.length && $pastSelect.length) {
        $futureSelect.on('change', clearPastSelect);
        $pastSelect.on('change', clearFutureSelect);
    }
});


//Functions needed for creating list manually

function convertToSeconds(duration) {
    if (duration != "None") {
        let secs_to_add = parseInt(duration.slice(-2));

        let mins_to_add = parseInt(duration.substr(-5, 2));
        secs_to_add += (mins_to_add * 60);

        let hours_to_add = parseInt(duration.substr(-8, 2));
        secs_to_add += (hours_to_add * 60 * 60)

        return secs_to_add
    }
}

function secondsToString(total_time){
    let hours = (total_time / (60*60))  >> 0;
    let minutes = total_time % (60*60);
    clear_minutes = (minutes / 60) >>0;
    let seconds = minutes % 60;

    if (clear_minutes <10) {
        clear_minutes = "0" + clear_minutes;
    }

    if (seconds <10) {
        seconds = "0" + seconds;
    }

    total_time_string = hours + ":" + clear_minutes + ":" + seconds;

    return total_time_string;
}


const $time_counter = $("#time_counter");
let total_time = 0;
let numb_songs_without_times = 0

if($time_counter.length > 0){
    //total time in seconds
    total_time = convertToSeconds($time_counter.html());
}

function addToList(song_id, duration){
    const $addedSong = $('#selectedSongs-' + song_id);
    $addedSong
        .appendTo($addedSong.parent())
        .removeClass('d-none')
    ;

    var checkBox_to_search = "checkbox-" + song_id;
    document.getElementById(checkBox_to_search).checked = true;

    //  before counting times we have to define these variables,
    //  and then, after counting, we have to change class
    var song_to_mark_checked = "SongList-" + song_id;
    var song_on_the_list = document.getElementById(song_to_mark_checked);

    // now, if song is not already included
    if (!song_on_the_list.classList.contains("selected")){

        if (duration != "None") {
            secs_to_add = convertToSeconds(duration);
            total_time += secs_to_add;
            total_time += 20;

            time_to_display = secondsToString(total_time);
            $time_counter.html(time_to_display);

        } else {
            numb_songs_without_times += 1;
        }
    }

    if (numb_songs_without_times > 0) {
        document.getElementById('not_all_have_times').innerHTML = "<br>Nie wszystkie utwory mają podany czas!";
    }

//    finally, we have to make selected song green on the list
    song_on_the_list.classList.add("selected");
}


function removeFromList(song_id, duration){
    var class_to_search = "selectedSongs-" + song_id;
    document.getElementById(class_to_search).classList.add("d-none");

    var checkBox_to_search = "checkbox-" + song_id;
    document.getElementById(checkBox_to_search).checked = false;

    var song_to_mark_checked = "SongList-" + song_id;
    var song_on_the_list = document.getElementById(song_to_mark_checked);

    if (duration != "None") {
            secs_to_add = convertToSeconds(duration);
            total_time -= secs_to_add;
            total_time -= 20;

            time_to_display = secondsToString(total_time);

            $time_counter.html(time_to_display);

        } else {
            numb_songs_without_times -= 1;
        }

    if (numb_songs_without_times == 0) {
        document.getElementById('not_all_have_times').innerHTML = "";
    }

    song_on_the_list.classList.remove("selected");
}

});